export default {
  className: 'record',
  perPage: 10,
  mixin: {
    fields: [
      {
        name: 'coupon',
        note: '卡券',
        render: (record) => {
          return `${record.coupon.name}`
        }
      },
      {
        name: 'use',
        note: '是否使用'
      },
      {
        name: 'createdAt'
      },
      {
        name: 'updatedAt'
      }
    ],
    search: [
      'user',
      'use'
    ],
    action: {
      delete: false,
      create: false,
      edit: false
    }
  }
}
